import './compare.scss';
import { AjaxLoader } from './../../lib/ajax-load-promise';
import Swiper, { Navigation, Manipulation } from 'swiper';

class Compare {
    constructor ($element) {
        this.$compare = $element;
        this.$slider = this.$compare.querySelector('[data-compare="slider"]');
        this.$slidePrev = this.$compare.querySelector('[data-compare="prev"]');
        this.$slideNext = this.$compare.querySelector('[data-compare="next"]');
        this.$compareItems = this.$compare.querySelectorAll('[data-compare="item"]');
        this.$addItem = document.querySelector('[data-add-compare]');
        this.$emptyItem = document.querySelector('[data-empty-compare]');
        this.$addButton = document.querySelector('[data-add-button]');
        this.$overlayAddProducts = document.querySelector('[data-compare-add-products]');
        this.count = this.$compareItems.length + 1;
        this.$availableItems = items; // eslint-disable-line no-undef
        this.customEvent = new CustomEvent('newbookmark');

        this.$mainProduct = this.$compare.querySelector('.compare__main-product');

        this.highestElements = {};

        this.slider = null;
        this.$overlay = document.querySelector('[data-compare-overlay="root"]');
        this.$overlayClose = this.$overlay.querySelector('[data-compare-overlay="close"]');

        this.breakPoints = {
            xxs: 320,
            s: 480,
            m: 768,
            l: 1024
        };

        this.lastBrowserSize = null;
    }

    initialize () {
        this.initSlider();
        this.checkSize(window.innerWidth);
        this.copyContent();
        this.setEqualHeight();
        this.fillOverlay();
        this.setEvents();
    }

    setEvents () {
        this.$addButton.addEventListener('click', (e) => {
            e.preventDefault();
            document.body.classList.add('has--overlay');
            this.$overlay.classList.remove('is--hidden');
            this.$overlay.classList.add('is--visible');
        });

        this.$overlayClose.addEventListener('click', () => {
            this.closeOverlay();
        });

        this.$overlayAddProducts.addEventListener('click', () => {
            const products = this.$overlay.querySelectorAll('input[type="checkbox"]:not(:disabled):checked');
            this.closeOverlay();
            this.loadProducts(products);
        });

        this.$slider.addEventListener('change', (e) => {
            if (e.target.checked === false) {
                const $slide = e.target.closest('.swiper-slide');
                this.removeCompareItem($slide);
            }
        });
    }

    copyContent () {
        const $itemGroups = this.$mainProduct.querySelectorAll('[data-item-group]');
        for (let i = 0; i < $itemGroups.length; i++) {
            this.$addItem.appendChild($itemGroups[i].cloneNode(true));
            this.$emptyItem.appendChild($itemGroups[i].cloneNode(true));
        }
    }

    removeCompareItem ($slide) {
        this.$compareItems = this.$compare.querySelectorAll('[data-compare="item"]');

        for (let i = 0; i < this.$compareItems.length; i++) {
            if ($slide === this.$compareItems[i]) {
                const id = $slide.querySelector('input').getAttribute('id');
                $slide.classList.add('is--hidden');
                this.setInsideOverlay(id);

                setTimeout(() => {
                    this.slider.removeSlide(i - 1);
                }, 750);
            }
        }
    }

    setBookmarkEvent ($element) {
        const $bookmarkItem = $element.querySelector('[data-bookmark]:not([data-bookmark-remove])');
        if ($bookmarkItem) {
            import('../../components/bookmark/bookmark').then(({ Bookmark }) => {
                const bookmark = new Bookmark($bookmarkItem, {
                    type: 'item'
                });
                bookmark.setItemEvents();
            });
        }
    }

    closeOverlay () {
        this.$overlay.classList.remove('is--visible');
        document.body.classList.remove('has--overlay');
        setTimeout(() => {
            this.$overlay.classList.add('is--hidden');
        }, 1000);
    }

    loadProducts (products) {
        for (let i = 0; i < products.length; i++) {
            AjaxLoader.getData(products[i].value).then((response) => {
                try {
                    response = JSON.parse(response);

                    this.slider.prependSlide(response.html);
                    this.setBookmarkEvent(document.querySelector('.compare__other-products__wrap [data-compare="item"]'));

                    if ((i + 1) === products.length) {
                        this.setEqualHeight();
                    }
                } catch {
                    console.warn('could not parse json');
                }
            });
            this.setInsideOverlay(products[i].id, true);
        }
        setTimeout(() => {
            this.slider.update();
            if (this.slider !== null) {
                this.checkLength();
            }
            this.slider.slideTo(0);
        }, 750);
    }

    setInsideOverlay (id, show) {
        const $input = this.$overlay.querySelector('input[id="' + id + '"]');
        const $element = $input.closest('.products-overview__teaser');

        if (show) {
            $input.disabled = true;
            $element.classList.add('is--hidden');
        } else {
            $input.disabled = false;
            $input.checked = false;
            $element.classList.remove('is--hidden');
        }
    }

    checkLength () {
        if (this.slider.slides.length >= 2) {
            if (this.slider.slides.length - 2 === 0 || this.slider.activeIndex === (this.slider.slides.length - 2)) {
                this.slider.allowSlideNext = false;
                this.$slideNext.classList.add('swiper-button-disabled');
            } else {
                this.slider.allowSlideNext = true;
                this.$slideNext.classList.remove('swiper-button-disabled');
            }
        } else {
            if (this.slider.slides.length === 2) {
                this.slider.allowSlideNext = false;
                this.$slideNext.classList.add('swiper-button-disabled');
            }
        }
    }

    initSlider () {
        if (this.slider === null || typeof this.slider === 'undefined') {
            this.slider = new Swiper(this.$slider, {
                modules: [Navigation, Manipulation],
                slidesPerView: 'auto',
                resistanceRatio: 0,
                width: 126,
                speed: 500,
                spaceBetween: 12,
                navigation: {
                    prevEl: this.$slidePrev,
                    nextEl: this.$slideNext
                },
                breakpoints: {
                    480: {
                        width: 200,
                        spaceBetween: 12
                    },
                    1024: {
                        width: 296,
                        spaceBetween: 14
                    }
                },
                on: {
                    slideChange: () => {
                        this.checkLength();
                        if (this.slider.activeIndex === this.slider.slides.length - 1) {
                            this.slider.slideTo(this.slider.slides.length - 2);
                        }
                    }
                }
            });

            // this.slider.allowSlideNext = false;
            setTimeout(() => {
                this.slider.update();

                if (this.slider !== null) {
                    this.checkLength();
                }
            }, 500);
        }
    }

    destroySlider () {
        if (this.slider !== null) {
            this.slider.destroy(true, true);
            this.slider.style = '';
            this.activeIndex = 0;
            this.slider = null;
        }
    }

    checkSize (browserWidth) {
        if (browserWidth < this.breakPoints.s) {
            if (this.lastBrowserSize !== this.breakPoints.xxs) {
                this.lastBrowserSize = this.breakPoints.xxs;
                this.setEqualHeight();
            }
        } else if (browserWidth >= this.breakPoints.s && browserWidth < this.breakPoints.m) {
            if (this.lastBrowserSize !== this.breakPoints.s) {
                this.lastBrowserSize = this.breakPoints.s;
                this.setEqualHeight();
            }
        } else if (browserWidth >= this.breakPoints.m && browserWidth < this.breakPoints.l) {
            if (this.lastBrowserSize !== this.breakPoints.m) {
                this.lastBrowserSize = this.breakPoints.m;
                this.setEqualHeight();
            }
        } else if (browserWidth >= this.breakPoints.l) {
            if (this.lastBrowserSize !== this.breakPoints.l) {
                this.lastBrowserSize = this.breakPoints.l;
                this.setEqualHeight();
            }
        }
    }

    setEqualHeight () {
        const checkHeight = () => {
            for (let i = 0; i < this.$compareItems.length; i++) {
                const $elements = this.$compareItems[i].querySelectorAll('[data-item-height]');

                for (let a = 0; a < $elements.length; a++) {
                    $elements[a].style.height = '';
                    if (i === 0) {
                        this.highestElements[$elements[a].getAttribute('data-item-height')] = $elements[a].scrollHeight;
                    } else {
                        if ($elements[a].scrollHeight > this.highestElements[$elements[a].getAttribute('data-item-height')]) {
                            this.highestElements[$elements[a].getAttribute('data-item-height')] = $elements[a].scrollHeight;
                        }
                    }
                }
            }
        };

        const setHeight = () => {
            for (let i = 0; i < this.$compareItems.length; i++) {
                for (const [key, value] of Object.entries(this.highestElements)) {
                    const $item = this.$compareItems[i].querySelector('[data-item-height="' + key + '"]');
                    if ($item) {
                        $item.style.height = value + 'px';
                    }
                }
            }
        };

        if (this.slider != null) {
            setTimeout(() => {
                this.$compareItems = this.$compare.querySelectorAll('[data-compare="item"]');
                checkHeight();
                setHeight();
                window.dispatchEvent(this.customEvent);
            }, 300);
        }
    }

    fillOverlay () {
        let template = '';

        for (let i = 0; i < this.$availableItems.length; i++) {
            template += '<div class="products-overview__teaser" data-compare-add="' + this.$availableItems[i].id + '">';
            template += '<figure class="products-overview__teaser-image"><img src="' + this.$availableItems[i].image + '" alt="' + this.$availableItems[i].name + '"></figure>';
            template += '<div class="products-overview__teaser-content"><p class="products-overview__teaser-type">' + this.$availableItems[i].category + '</p>';
            template += '<h3 class="products-overview__teaser-name">' + this.$availableItems[i].name + '</h3>';
            template += '<div class="checkbox"><input type="checkbox" name="' + this.$availableItems[i].id + '" id="' + this.$availableItems[i].id + '" value="' + this.$availableItems[i].url + '"><label for="' + this.$availableItems[i].id + '"></label></div></div></div>';
        }

        this.$overlay.querySelector('[data-compare-overlay="target"]').innerHTML = template;
    }
}

export { Compare };
